import { render, staticRenderFns } from "./InternInformedConsent.vue?vue&type=template&id=6fa46599"
import script from "./InternInformedConsent.vue?vue&type=script&lang=js"
export * from "./InternInformedConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports